import React, { createSearchParams, NavigateFunction, RouteObject } from "react-router-dom";
import { focus_viewMenu_Pages } from "../pages";

// TODO
import FV_Operations from "../../Containers/FocusViewScreens/fv_operations";
import OP_Animals from "../../Containers/FocusViewScreens/op_animals";
import FV_QuickEntry from "../../Containers/FocusViewScreens/fv_quickEntry";
import FV_FreedaLF from "../../Containers/FocusViewScreens/SystemScreens/fv_freeda_lf";

export const Router = [{
  element: null,
  children: [
    {index: true, path:`/${focus_viewMenu_Pages.op_operations}`, element:<FV_Operations/>},
    {path:`/${focus_viewMenu_Pages.op_animals}`, element:<OP_Animals/>},
    {path: `/${focus_viewMenu_Pages.op_quickEntry}`, element: <FV_QuickEntry /> },
    {path:`/${focus_viewMenu_Pages.op_freeda_lf}/:systemId`, element:<FV_FreedaLF/>}
  ]
}] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page:focus_viewMenu_Pages, currentDomain?: string) => {
  
  const search = currentDomain ? createSearchParams({domain: currentDomain }).toString() : undefined;
  switch (navigation_page) {
    case focus_viewMenu_Pages.home:
      Navigator({pathname:focus_viewMenu_Pages.home, search})
    break
    case focus_viewMenu_Pages.op_operations:
      Navigator({pathname: "../"+focus_viewMenu_Pages.op_operations, search})
    break
    case focus_viewMenu_Pages.op_animals:
      Navigator({pathname:"../"+focus_viewMenu_Pages.op_animals, search})
    break
    case focus_viewMenu_Pages.op_quickEntry:
      Navigator({pathname:"../"+focus_viewMenu_Pages.op_quickEntry, search})
      break
    case focus_viewMenu_Pages.op_freeda_lf:
      Navigator({pathname:"../"+focus_viewMenu_Pages.op_freeda_lf, search})
    break
    default:
      console.log("Error page not found (404)???, [ToolsMenu]")
  }
}
